import axios, { type AxiosResponse, type AxiosError } from 'axios'

const baseURL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:5000'

export const apiClient = axios.create({
  baseURL,
  timeout: 120_000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

// ─── Request interceptor ────────────────────────────────────────────────────

apiClient.interceptors.request.use(
  (config) => {
    // Attach auth token if present
    const token = localStorage.getItem('codetobyte-token')
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error: AxiosError) => Promise.reject(error),
)

// ─── Response interceptor ───────────────────────────────────────────────────

apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response) {
      const status = error.response.status
      if (status === 401) {
        // Clear stale token on unauthorised responses
        localStorage.removeItem('codetobyte-token')
      }
      // Surface a readable message from the response body when available
      const body = error.response.data as Record<string, unknown> | null
      const serverMessage =
        typeof body?.error === 'string'
          ? body.error
          : typeof body?.message === 'string'
            ? body.message
            : null

      if (serverMessage) {
        return Promise.reject(new Error(serverMessage))
      }
    } else if (error.request) {
      return Promise.reject(new Error('No response received from server. Check your connection.'))
    }

    return Promise.reject(error)
  },
)

export default apiClient
